<template>
    <div class="scenes-list">
        <!--item-scroll-container有個 v-if="sceneGroups.length > 0"-->
        <div class="item-scroll-container">
            <div class="item-wrapper">
                <draggable
                        v-model="sceneIdGroup"
                        delay='200'
                        delay-on-touch-only='true'
                        :distance="1"
                        :disabled="isDragging"
                        style="display: flex"
                        @start="onDragStart"
                        @end="onDragEnd"
                >
                    <!--場景列表-->
                    <div
                            class="item-bg"
                            v-for="(sceneIdx, index) in sceneIdGroup"
                            :key="index"
                    >
                        <div
                                class="item-img"
                                @click="loadScene(sceneIdx)"
                                :class="currScene.includes(sceneIdx)? 'active' : ''"
                        >
                            <div class="item-title">{{allScenes && allScenes[sceneIdx].scene_title}}</div>
                            <img
                                    class="scene-img"
                                    :src="allScenes && allScenes[sceneIdx].thumb_path"
                                    alt="img"
                            />
                        </div>
                    </div>
                </draggable>
            </div>
        </div>
        <div v-if="isEdit" class="add-scenes" @click="onClickAddScene">
            <img src="../../assets/img/mob_add_scene.png"/>
            <h5>增加場景</h5>
        </div>
    </div>
</template>

<script>
    import draggable from "vuedraggable";
    import {mapGetters} from "vuex";
    export default {
        name: "SceneList",
        components:{
            draggable
        },
        props:{
            scenesList:{
                type: Array,
                default: ()=>[]
            },
            currScene:{
                type: Array,
                default: ()=>[]
            },
            isEdit:{
                type: Boolean,
                default: true
            },
            allScenes:{
                type:Object,
                default: ()=>{}
            },
            isDragging:{
                type: Boolean,
                default: true
            },
            currGroupId:{
                type: Number,
                defalut: 0
            }
        },
        data(){
            return{
                sceneIdGroup:[]
            }
        },
        computed: {...mapGetters(["vrbase"])},
        watch:{
            scenesList:{
                handler(newVal){
                    let sceneArray = []
                    newVal.forEach(obj => {
                        Object.keys(this.allScenes).forEach(key => {
                            if(obj == key){
                                sceneArray.push(obj)
                            }
                        })
                    })
                    this.sceneIdGroup = sceneArray
                }
            }
        },
        created() {
            let sceneArray = []
            this.scenesList.forEach(obj => {
                Object.keys(this.allScenes).forEach(key => {
                    if(obj == key){
                        sceneArray.push(obj)
                    }
                })
            })
            this.sceneIdGroup = sceneArray
        },
        methods: {
            onDragStart(ev){
                ev.item.style.opacity = 0;
                ev.to.ondrop = function (even) {
                    even.preventDefault();
                    even.stopPropagation();
                };
            },
            //移動場景後處理順序
            onDragEnd(event) {
                event.item.style.opacity = 1;
                event.preventDefault();
                event.stopPropagation();
                const oldIndex = event.oldIndex;
                const newIndex = event.newIndex;
                if (oldIndex === newIndex) return;
                this.$emit('dragEnd',this.sceneIdGroup);
                return;
                // 獲取當前分組的場景列表
                let sceneGroup = this.vrbase.scene_group.groups;
                const currGroupCenceList = this.sceneIdGroup;
                sceneGroup[this.currGroupId].scenes = currGroupCenceList
                currGroupCenceList.forEach((obj,index) => {
                    this.vrbase.scenes[obj].sort_order = index;
                })
                this.updateStore(this.vrbase);
            },
            //場景加載
            loadScene(id){
                this.$emit('loadScene',id)
            },
            //添加場景
            onClickAddScene(){
                this.$emit('addScene')
            }
        }
    }
</script>

<style lang="less" scoped>
    /*場景列表*/
    .scenes-list {
        /*padding: 0 16px 8px 16px;*/
        padding-bottom: 8px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .item-scroll-container {
            overflow: hidden;
            flex: 1;
            position: relative;
            .item-wrapper {
                -webkit-touch-callout: none;
                display: flex;
                justify-content: flex-start;
                overflow-x: scroll;
                width: 100%;
                &::-webkit-scrollbar {
                    display: none;
                }
                .item-bg {
                    width: 68px;
                    margin-right: 8px;
                    &:last-child{
                        margin-right: 16px;
                    }
                    &:first-child{
                        margin-left: 16px;
                    }
                    .item-img {
                        position: relative;
                        width: 68px;
                        height: 68px;
                        border-radius: 4px;
                        overflow: hidden;
                        border: 2px solid transparent;
                        &.active{
                            border: 2px solid #015c61;
                        }
                        img {
                            width: 68px;
                            height: 68px;
                            object-fit: contain;
                            pointer-events: none;
                        }
                        .item-title {
                            line-height: 150%;
                            position: absolute;
                            right: 0;
                            left: 0;
                            bottom: 0;
                            height: 20px;
                            text-align: center;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            color: rgba(229, 229, 229, 1);
                            background-image: linear-gradient(to bottom,rgba(0,0,0,0),rgba(0,0,0,.5));
                            font-size: 12px;
                            pointer-events: none;
                        }
                    }
                }
            }
        }

        /*添加場景按鈕*/
        .add-scenes {
            flex-shrink: 0;
            height: 68px;
            text-align: center;
            margin: 0 16px;
            padding-top: 12px;
            h5{
                color: #ffffff;
                margin: 4px 0 0 0;
            }
            img{
                width: 22px;
                height: 22px;
            }
        }
    }
</style>
